<template>
  <div class="page-bar clearfix">
    <!-- <div class="shop-settings">
      <a id="list-anchor" class="active">
        <i class="fas fa-th-list"></i>
      </a>
      <a id="grid-anchor">
        <i class="fas fa-th"></i>
      </a>
    </div> -->
    <!-- Toolbar Sorter 1  -->
    <div class="toolbar-sorter">
      <div class="select-box-wrapper">
        <label class="sr-only" for="sort-by">Sort By</label>
        <select
          class="select-box"
          id="sort-by"
          v-model="type"
          @change="handleSort($event)"
        >
          <option selected value="featured">Sort By: Featured</option>
          <option value="best-selling">Sort By: Best Selling</option>
          <option value="latest">Sort By: Latest</option>
          <option value="lowest_price">Sort By: Lowest Price</option>
          <option value="highest_price">Sort By: Highest Price</option>
          <option value="best_rating">Sort By: Best Rating</option>
        </select>
      </div>
    </div>
    <!-- //end Toolbar Sorter 1  -->
    <!-- Toolbar Sorter 2  -->
    <!-- <div class="toolbar-sorter-2">
      <div class="select-box-wrapper">
        <label class="sr-only" for="show-records">Show Records Per Page</label>
        <select class="select-box" id="show-records">
          <option selected="selected" value="">Show: 8</option>
          <option value="">Show: 16</option>
          <option value="">Show: 28</option>
        </select>
      </div>
    </div> -->
    <!-- //end Toolbar Sorter 2  -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      type: "featured",
    };
  },
  methods: {
    ...mapActions("products", ["getProductByCategoryId", "fetchBrands"]),
    handleSort(event) {
      //   console.log(event.target.value);
      this.$emit("sortBy", event.target.value);
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id || to.query.category_id) {
        this.type = "featured";
      }
    },
  },
};
</script>

<style>
</style>